import { Routes } from "@angular/router";
import { authGuard } from "../../../core/guards/auth.guard";
import { TelegramPageComponent } from "./telegram-page.component";

export const telegramPageRoutes: Routes = [
  {
    path: 'telegram',
    canActivate: [authGuard],
    component: TelegramPageComponent
  }
]
